export default "__VITE_ASSET__DeG02xDf__"